module.exports = __webpack_public_path__ + "img/closed-account.f4558729.png";